import { EPlatformTravelType as TravelType } from '@umu/umu-types';
import { IDepartListInfo } from '@umu/umu-api';
import { lang } from '@umu/ukit-lang';
import { IListItem, IRoute } from './type';

/**
 * @description: 部门 id 常量
 * 组织架构 -1
 *    企业根部门 0
 *       部门 xx
 *       部门 xx
 */
export const originStructureId = '-1';
export const rootDepartmentId = '0';
export const originBreadcrumbItem: IRoute = {
    name: lang('组织架构'),
    path: originStructureId,
};

/**
 * @description: 是否为 组织架构
 * @param {string} departmentId
 * 组织架构 -1
 *    企业根部门 0
 *       部门一 xx
 *       部门二 xx
 */
export const isOriginStructure = (departmentId?: string) => {
    return !departmentId || Number(departmentId) === Number(originStructureId);
};

/**
 * @description: 是否为 企业根部门
 * @param {string} departmentId
 * 组织架构 -1
 *    企业根部门 0
 *       部门一 xx
 *       部门二 xx
 */
export const isRootDepartment = (departmentId?: string) => {
    return Number(departmentId) === Number(rootDepartmentId);
};

export const genRootDepartmentOriData = (info: IDepartListInfo) => {
    return {
        key: rootDepartmentId,
        department_id: rootDepartmentId,
        department_name: info.show_name,
        parent_department_id: rootDepartmentId,
        member_count: info.member_count,
        show_index: '',
        enterprise_id: '',
        level: '0',
        have_child_departments_flag: 1,
        is_del: 0,
        manage_permission: info.manage_permission,
        managers: [],
        child_path: [],
        parent_path: [],
        children: [],
        exclude_umu_ids: [],
    };
};

export const genRootDepartmentData = (info: IDepartListInfo) => {
    return Object.assign(
        { isSelected: false, type: TravelType.department },
        {
            key: rootDepartmentId,
            name: info.show_name || '',
            id: rootDepartmentId,
            checkable: true,
            oriData: genRootDepartmentOriData(info),
            isHaveNextLevel: true,
        },
    );
};

export const compare = (p: string) => {
    return (a: any, b: any) => {
        return Number(a[p]) - Number(b[p]);
    };
};

export const renderMemberCount = (params: IListItem) => {
    const { oriData = {} } = params;
    const { member_count, exclude_umu_ids = [] } = oriData;
    return `${member_count - exclude_umu_ids.length}/${member_count}`;
};

export const getMemberCount = (params: IListItem) => {
    const { oriData = {} } = params;
    const { member_count, exclude_umu_ids = [] } = oriData;
    return {
        total: member_count,
        selected: member_count - exclude_umu_ids.length,
    };
};

export const isLoadEnd = (page_info: IPageInfo) => {
    return page_info.current_page >= page_info.total_page_num;
};

export enum FilterDialogListType {
    memberList,
    subMemberList,
}

export const filterDialogDefaultMemberList = {
    page_info: {
        current_page: 0,
        list_total_num: 0,
        total_num: 0,
        size: 50,
        total_page_num: 0,
    },
    list: [],
    type: FilterDialogListType.memberList,
};

export const limitSelectedCount = 300; // 已选数量限制

export const limitExcludeUmuIdsCount = 100; // 排除数量限制

export function getMemberKeyByItem(item: any) {
    const umu_id = item.id || item.oriData.users_info.umu_id;
    const department_id = item.oriData.department_id;
    return department_id ? `${TravelType.owner}-${department_id}-${umu_id}` : `${TravelType.owner}-${umu_id}`;
}

/**
 * @description: 构造 MemberItem
 *
 */

export function normMemberItem(item: any, isSelected?: boolean): IListItem {
    const user_info = item.user_info || item;
    const umu_id = user_info.umu_id || user_info.id;
    const user_name = user_info.user_name || user_info.name;

    const itemNew = {
        key: '',
        id: umu_id,
        name: user_name,
        checkable: true,
        type: TravelType.owner,
        avatar: user_info.avatar,
        isSelected: isSelected == undefined ? false : isSelected,

        oriData: {
            ...item,
            umu_id,
            user_info,
            user_name,
            name: user_name,
        },
    };

    itemNew.key = getMemberKeyByItem(itemNew);

    return itemNew;
}
